module.exports = __webpack_public_path__ + "media/images/flags/32/Honduras-32a2c2c06724c24d77a7209d9cd69905.png";